import {ReactElement} from 'react';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import {Box} from '@mui/material';
import {IconContainerProps} from '@mui/material/Rating';

type Icon = {
  icon: ReactElement;
  label: string;
  color: string;
};

export const customIcons: Record<any, Icon> = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon />,
    label: 'veryDissatisfied',
    color: 'red'
  },
  2: {
    icon: <SentimentDissatisfiedIcon />,
    label: 'dissatisfied',
    color: 'orange'
  },
  3: {
    icon: <SentimentSatisfiedIcon />,
    label: 'neutral',
    color: 'gold'
  },
  4: {
    icon: <SentimentSatisfiedAltIcon />,
    label: 'satisfied',
    color: 'yellowgreen'
  },
  5: {
    icon: <SentimentVerySatisfiedIcon />,
    label: 'verySatisfied',
    color: '#04af65'
  }
};

export default function IconContainer({value, className, ...rest}: IconContainerProps) {
  const icon = customIcons[value];
  if (!icon) {
    return null;
  }
  return (
    <Box
      component="span"
      sx={{
        color: icon.color
      }}
      className={className}
      {...rest}
    >
      {icon.icon}
    </Box>
  );
}
